import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row-center" }
const _hoisted_2 = ["onContextmenu"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directLinks, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        onContextmenu: _withModifiers(($event: any) => (_ctx.onRightClick($event, index)), ["prevent"])
      }, [
        _createElementVNode("div", {
          class: "direct-link",
          onClick: ($event: any) => (_ctx.openUrl($event, index))
        }, [
          _createElementVNode("img", {
            src: item.icon,
            style: _normalizeStyle({'background-color': item.color})
          }, null, 12, _hoisted_4),
          _createElementVNode("div", null, _toDisplayString(item.name), 1)
        ], 8, _hoisted_3)
      ], 40, _hoisted_2))
    }), 128))
  ]))
}